import { CustomSearchXStoreModule } from '../types';

// eslint-disable-next-line max-len
export const saveStorePreviewResponse: CustomSearchXStoreModule['actions']['saveStoreResultsResponse'] =
  ({ commit }, { storePreview }) => {
    if (storePreview) {
      commit('setStorePreview', storePreview);
    }
  };
